import React from "react";
import { useTranslation } from "react-i18next";
import { Avatar } from "../../../types/modules/admin/avatar.type";
import AvatarItem from "./AvatarItem";
import { PermissionGate } from "../PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  avatars: Avatar[];
}

const AvatarsTable: React.FC<Props> = ({ avatars }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal capitalize">{t("id")}</th>
            <th className="p-3 font-normal capitalize">{t("avatar")}</th>
            <PermissionGate permissions={[PermissionsKey.UpdateAvatar]}>
              <th className="p-3 font-normal capitalize">{t("actions")}</th>
            </PermissionGate>
          </tr>
        </thead>
        <tbody className="text-sm">
          {avatars.map((avatar) => (
            <tr
              key={avatar.id+"denkdj"}
              className="bg-white rounded-[12px]"
              style={{ boxShadow: "0px 4px 32px rgba(86, 92, 120, 0.08)" }}
            >
                <AvatarItem avatar={avatar}/>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default AvatarsTable;